import { render, staticRenderFns } from "./userGraphical.vue?vue&type=template&id=a808f0c6"
import script from "./userGraphical.vue?vue&type=script&lang=js"
export * from "./userGraphical.vue?vue&type=script&lang=js"
import style0 from "./userGraphical.vue?vue&type=style&index=0&id=a808f0c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UserHeader: require('/root/workspace/web-company_Yo6Q/components/userLogin/userHeader.vue').default})
